import { useState } from "react";
import { useGetPeriodicals } from "../api/useGetPeriodicals";
import { AutoComplete } from "./AutoComplete";
import { useDebounce } from "../../../../lib/hooks/useDebounce";

export const PeriodicalDropdown = ({ formData }) => {
  const [keyword, setKeyword] = useState("");
  const debouncedKeyword = useDebounce(keyword, 500);
  const periodicals = useGetPeriodicals(debouncedKeyword, formData);

  const onSelectSuggestion = (periodical) => () => {
    setKeyword("");
    formData.periodicals.onChange({ target: { value: periodical.value } });
  };

  return (
    <AutoComplete
      placeholder={formData.periodicals.values?.[0]}
      keyword={keyword}
      setKeyword={setKeyword}
      suggestions={periodicals}
      onSelectSuggestion={onSelectSuggestion}
      // disabled={!periodicals?.length}
    />
  );
};
